import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Typography, Space, Input, Row, Col } from 'antd';

import { CommonFormProps, OnboardingLayout } from '.';
import { Form } from '~/components';
import { setPassword } from '~/api/onboarding';
import { passwordMinLength } from '~/pages/login';
import onError from '~/errorsHandler';
import { useLogin } from '~/hooks/auth';
import { useOnboardingState } from '~/hooks/onboarding';

const { Title, Text } = Typography;

const CreatePassword: FC<CommonFormProps> = (props) => {
  const { history } = props;
  const { t } = useTranslation('onboarding');
  const dt = (key: string): string => t(`translation:${key}`);
  const [form] = Form.useForm();
  const [isLoading, setLoading] = useState(false);

  const loginController = useLogin();
  const [pageState] = useOnboardingState('createAccount');

  const onFinish = async (values: any) => {
    const { newPassword } = values;
    try {
      setLoading(true);
      await setPassword(newPassword);
      const email = pageState.formData?.email;
      if (email) {
        try {
          await loginController.login(email, newPassword);
          history?.push('/');
        } catch (error: any) {
          history?.push('/login');
        }
      }
    } catch (error: any) {
      onError(error);
    }
    setLoading(false);
  };

  return (
    <OnboardingLayout>
      <Title level={2}>{t('createPasswordHeader')}</Title>
      <Space size="middle" direction="vertical">
        <Text>{t('createPasswordSubtitle', { passwordMinLength })}</Text>
        <Form form={form} layout="vertical" size="large" onFinish={onFinish}>
          <Form.Item name="newPassword" rules={[{ required: true, min: passwordMinLength }]}>
            <Input.Password placeholder={dt('password')} />
          </Form.Item>
          <Form.Item
            name="newPasswordAgain"
            dependencies={['newPassword']}
            rules={[
              {
                required: true,
              },
              ({ getFieldValue }) => ({
                validator(rule, value) {
                  if (!value || getFieldValue('newPassword') === value) {
                    return Promise.resolve();
                  }

                  // eslint-disable-next-line prefer-promise-reject-errors
                  return Promise.reject(dt('passwordsNotMatch'));
                },
              }),
            ]}
          >
            <Input.Password placeholder={dt('confirmPassword')} />
          </Form.Item>
          <Row gutter={16}>
            <Col>
              <Form.Item noStyle>
                <Button type="primary" htmlType="submit" loading={isLoading}>
                  {dt('continue')}
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Space>
    </OnboardingLayout>
  );
};

export default CreatePassword;
